import { BorderColor, VerticalAlignBottom } from "@mui/icons-material";
import { BsThreeDotsVertical } from "@/Components/Icons/Icons";
import { Divider } from "@mui/material";

export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "GSAAir",
            actionText: "G.S.A.(Air)",
            component: "typographytext",
            placeholder: "100.00%",
            width: "20%",
            sx: {
              // height:"65PX",
              alignItems: "center",
            },
          },
          {
            name: "overseasAgent",
            // checkboxLabel: "Overseas Agent",
            component: "checkboxBox",
          },
          {
            name: "commission",
            component: "text-field",
            placeholder: "100.00%",
            width: "20%",
            gap: false,
            dataType: "int",
          },
        ],
        row2: [
          {
            name: "IATACodeText",
            actionText: "IATA Code",
            component: "typographytext",
            placeholder: "100.00%",
            width: "28%",
            sx: {
              // height:"70PX",
              alignItems: "center",
            },
          },
          {
            name: "IATACode",
            component: "text-field",
            placeholder: "100.00%",
            width: "20%",
            gap: false,
            dataType: "int",
          },
        ],
        row3: [
          {
            name: "profitSharing",
            actionText: "Account No",
            component: "typographytext",
            placeholder: "100.00%",
            width: "28%",
            sx: {
              // height:"65PX",
              alignItems: "center",
            },
          },
          {
            name: "AccountNo",
            component: "text-field",
            placeholder: "100.00%",
            width: "20%",
            gap: false,
            dataType: "int",
          },
        ],
      },
    },
  ],
};
